module.exports = __webpack_public_path__ + "img/sand-taylormade.01d8cb98.png";